import { NotificationImportantOutlined } from "@mui/icons-material";
import { Divider, IconButton, Skeleton, Tooltip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import PlaceholderImage from "../../../assets/placeholder.jpg";
import { Icon } from "@iconify/react";
import globalStyles from "../../../../../../src/styles/globalStyles.module.css";
import { updateProductStatus } from "../../../../../api/product";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import { productSelector } from "../../../../../redux/slices/productSlice";

export default function ProductCardForDashboard({
  product,
  handleImageError,
  title,
  getProductStatusChips,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const windowWidth = useWindowWidth();
  const { isLoading } = useSelector(productSelector);

  return (
    <div
      key={product?._id}
      className="product_card"
      style={{
        height: "330px",
        position: "relative",
        boxShadow:
          "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
        borderRadius: "5px",
        marginLeft: "15px",
        overflow: "hidden",
      }}
    >
      <div style={{ position: "relative", padding: "10px 10px 0px 10px" }}>
        {isLoading ? (
          <Skeleton
            variant="rounded"
            height="180px"
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <img
            src={product?.images?.length > 0 ? product?.images[0]?.src : PlaceholderImage}
            onError={handleImageError}
            alt="product"
            style={{
              borderRadius: "8px",
              height: "130px",
              objectFit: "cover",
            }}
            className={`${globalStyles.w_100} ${globalStyles.h_100}`}
          />
        )}
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            padding: "5px 12px",
            borderRadius: "10px",
            color: "white",
            background: "rgba(142, 65, 254, 0.7)",
            display: product.is_new ? "block" : "none",
          }}
        >
          {isLoading ? (
            <Skeleton
              variant="rounded"
              height={20}
              width="100%"
              sx={{ marginTop: "10px" }}
            />
          ) : (
            <small style={{ color: "white", margin: 0 }}> New </small>
          )}
        </div>
      </div>
      {location?.pathname !== "/customer/products" &&
        (isLoading ? (
          <Skeleton
            variant="rounded"
            height={20}
            width={120}
            sx={{ margin: "10px 10px 0px 10px" }}
          />
        ) : (
          <div
            style={{
              margin: "0px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {windowWidth > 1300 && (
              <Icon
                icon="ri:store-2-line"
                width="15"
                height="15"
                style={{ color: "rgb(24, 144, 255)", marginTop: 0 }}
              />
            )}
            <h5
              style={{
                marginLeft: windowWidth > 1300 ? "5px" : "0px",
                fontSize: "10px",
                fontWeight: 500,
                marginTop: 0,
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {product?.store?.store_name}
            </h5>
          </div>
        ))}
      <div
        style={{
          padding: "0px 10px",
          display: "flex",
          justifyContent: "space-between",
        }}
        className={`${globalStyles.p_relative} ${globalStyles.w_100}`}
      >
        <div
          style={{
            width: "100%",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {isLoading ? (
            <Skeleton
              variant="rounded"
              height={20}
              width="100%"
              sx={{ marginTop: "10px" }}
            />
          ) : (
            <h5
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                fontSize: windowWidth > 1300 ? "14px" : "12px",
              }}
              className={`${globalStyles.font_16} ${globalStyles.deep_dark_gray}`}
            >
              {product.title || "Not available"}
            </h5>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
          >
            <div>
              {isLoading ? (
                <Skeleton
                  variant="rounded"
                  height={20}
                  width="100%"
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <h6
                  style={{
                    fontSize: windowWidth > 1300 ? "12px" : "11px",
                    fontWeight: 600,
                    marginTop: "10px",
                  }}
                >
                  Store Price:
                  <b>
                    {product?.variants
                      ? "€" + product?.variants[0].price
                      : " Not Available"}
                  </b>
                </h6>
              )}
              {isLoading ? (
                <Skeleton
                  variant="rounded"
                  height={20}
                  width="100%"
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <h6
                  style={{
                    fontSize: windowWidth > 1300 ? "12px" : "11px",
                    fontWeight: 600,
                  }}
                >
                  Quoted Price:
                  <b>
                    {product?.variants?.length > 0 &&
                    product?.status === "accepted"
                      ? ` €${product?.variants[0]?.original_price}`
                      : " Unavailable"}
                  </b>
                </h6>
              )}
            </div>
            {product?.variants?.filter(
              (variant) => variant?.acceptance === false
            ).length > 0 && (
              <div>
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#ffff",
                        maxWidth: "450px",
                        width: "auto",
                        boxShadow:
                          "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 35%) 0px 12px 24px -4px",
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 500,
                        padding: "15px",
                        textAlign: "left",
                      },
                    },
                    arrow: {
                      sx: {
                        fontSize: 16,
                        color: "#ffff",
                      },
                    },
                  }}
                  title={
                    <div>
                      <>
                        <h5 style={{ fontSize: "16px" }}>Unable to quote</h5>
                        <Divider />

                        {product?.variants
                          ?.filter((variant) => variant?.acceptance === false)
                          .map((variant, i) => (
                            <div
                              key={variant.variant_id}
                              style={{
                                // marginBottom: "20px",
                                display: "flex",
                                alignItems: "baseline",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                }}
                              >
                                {i + 1}.
                              </span>
                              <div style={{ marginLeft: "5px" }}>
                                <h6 style={{ fontWeight: 500 }}>
                                  Variant ID: {variant.variant_id}
                                </h6>
                                <h6 style={{ fontWeight: 500 }}>
                                  Variant Title: {variant.title}
                                </h6>
                              </div>
                            </div>
                          ))}
                      </>
                    </div>
                  }
                  placement="bottom"
                  style={{ color: "tomato" }}
                  arrow
                >
                  <IconButton>
                    <NotificationImportantOutlined />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      {product?.variants?.length > 0 && product.status === "accepted" && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            padding: "0px 10px 10px 10px",
            marginTop: "0px",
            // marginBottom: "40px",
          }}
        >
          {product?.variant_options?.map((variant) => (
            <div
              style={{
                padding: "3px 5px",
                borderRadius: "8px",
                background: "#eee",
                marginRight: "5px",
                marginBottom: "5px",
                textAlign: "center",
                color: "#000",
                width: "auto",
              }}
            >
              <small>{variant?.option}</small>
            </div>
          ))}
        </div>
      )}

      <div
        style={{
          padding: "0px 10px",
          position: "absolute",
          width: "100%",
          textAlign: "center",
          bottom: "10px",
          marginTop: `${product?.variants?.length > 0 ? "0px" : "20px"}`,
        }}
      >
        {product?.status === "accepted" ? (
          isLoading ? (
            <Skeleton
              variant="rounded"
              height={20}
              width="100%"
              sx={{ margin: "" }}
            />
          ) : (
            <Link
              onClick={() => dispatch(updateProductStatus(product._id))}
              to={`${title ? `/admin/products/${product?._id}` : product?._id}`}
              style={{
                marginTop: "0px",
                textAlign: "center",
                color: "rgba(142, 65, 254, 0.7)",
              }}
            >
              View details
            </Link>
          )
        ) : (
          <div>
            {isLoading ? (
              <Skeleton
                variant="rounded"
                height={30}
                width="100%"
                sx={{ margin: "" }}
              />
            ) : (
              getProductStatusChips(product)
            )}
          </div>
        )}
      </div>
    </div>
  );
}
